import './jquery';
import './polyfill';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'slick-carousel';
import 'jquery.nicescroll';
import 'magnific-popup';
import 'waypoints/lib/noframework.waypoints.min.js';
import './sliders';
import './form-validate';
import './qty';
import './tabs';
import './accordion';
import './arc-text';
import './mobile-navigation';
import './map';
import './account';
import './quick-form';
import './cart';
import './quick-add';
import './images';
import './checkout';
import './dropdown';
import './order-lookup';
import './faq';
import './product';
import './catalog';
import './jquery.arctext';
import './newsletterFormSuccess';
import './subscribe';

$(document).ready(function ($) {
  try {
    if ($('.intro__slide_info').length > 0) {
      $('.intro__slide_info h1').arctext({ radius: 180 });
    }

    $('a[href^="http"]')
      .not('a[href^="' + location.protocol + '//' + location.hostname + '"]')
      .not('a[href^="/"]')
      .attr('target', '_blank')
      .attr('rel', 'noopener');

    $('.utility__search a').on('click', function () {
      $('.utility__search > .form-holder').toggle();
      $('#searchField').focus();
    });

    $('.utility__search .close').on('click', function () {
      $('.utility__search > .form-holder').hide();
    });

    sessionStorage.setItem('visited', true);
  } catch (e) {
    Rollbar.error('general index js', e);
  }
});
